<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Campaign -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
            <button type="button" class="btn btn-primary" @click="save()">Save</button>
            <button type="button" class="btn btn-primary" @click="saveAndClose()">Save & close</button>
            <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </template>
                    <div class="alert alert-danger" v-if="err">{{err}}</div>
                    <div class="alert alert-success" v-if="success">{{success}}</div>
        <div class="row">
            <div class="col-6">
                <fieldset class="mb-3" :class="{'loading-mask': loading}">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-6">Throttle send (mail per hour)</label>
                        <div class="col-lg-6">
                            <input type="number" class="form-control" v-model="form.send_limit">
                            <small>Value "0" means - no throttling</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Random sentences (one per line)</label>
                        <div class="col-lg-10">
                            <ace-editor :editor-id="'random_sentences'" @change-content="contentChanged2" :content="form.random_sentences || ''" lang="text" theme="monokai" v-bind:style="{'width':'100%', height: '100px'}"></ace-editor>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Random subjects (one per line)</label>
                        <div class="col-lg-10">
                            <ace-editor :editor-id="'random_subjects'" @change-content="contentChanged3" :content="form.random_subjects || ''" lang="text" theme="monokai" v-bind:style="{'width':'100%', height: '100px'}"></ace-editor>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <button class="btn btn-primary" style="margin-bottom: 5px" @click="show_help = !show_help">Toggle help</button>
                            <div class="alert alert-primary" v-if="show_help">
                                <strong>Manual:</strong>
                                <p>Use <strong v-html="'[unsubscribe_url]'"></strong> to place an URL to unsubscribe.</p>
                                <p>Use <strong v-html="'{{random_sentence}}'"></strong> to place a random sentence from above.</p>
                                <p>There are also contact data available:
                                    <strong v-html="'{{template}}'"></strong>,
                                    <strong v-html="'{{domain}}'"></strong>,
                                    <strong v-html="'{{first_name}}'"></strong>,
                                    <strong v-html="'{{last_name}}'"></strong>,
                                    <strong v-html="'{{address}}'"></strong>,
                                    <strong v-html="'{{city}}'"></strong>,
                                    <strong v-html="'{{zip_code}}'"></strong>,
                                    <strong v-html="'{{state}}'"></strong>
                                </p>
                                <p v-html="'{{#first_name}} this will show if first_name IS NOT EMPTY{{/first_name}}'"></p>
                                <p v-html="'{{^first_name}} this will show if first_name IS EMPTY{{/first_name}}'"></p>
                                <p>You can use conditional expressions with all contact fields</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-4">Select template tags or fill content below</label>
                        <div class="col-lg-8">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.message_templates" tag-placeholder=""
                                    @search-change="templateFind" :searchable="true" :loading="loadingTypeahead"
                                    placeholder="Search for a template TAG" label="_id" track-by="_id"
                                    :options="templateList || []" :multiple="true"></multiselect>
                            </div>
                        </div>
                        <label class="col-form-label col-lg-4">Select template by name</label>
                        <div class="col-lg-8">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.message_template_id" tag-placeholder=""
                                    @search-change="templateFindByName" :searchable="true" :loading="loadingTypeahead"
                                    placeholder="Search for a template name" label="name" track-by="_id"
                                    :options="templateList || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-6">
                <fieldset class="mb-3" :class="{'loading-mask': loading}">
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Campaign name</label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="form.name">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Subject</label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="form.subject">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">
                            Sender address
                        </label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="form.sender_address">
                            <small>(the part before @, ex. <strong>noreply</strong>@domain.com</small>
                            <small>Leave it blank and it will be filled with values from default names in settings</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-2">Sender name</label>
                        <div class="col-lg-8">
                            <input type="text" class="form-control" v-model="form.sender_name">
                            <small>Leave it blank and it will be filled with values from default names in settings</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-3">Choose contact list</label>
                        <div class="col-lg-8">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.list" tag-placeholder="" 
                                @search-change="contactListFind"
                                :searchable="true" :loading="loadingTypeahead"
                                placeholder="Search for a contact list" label="name" track-by="_id" :options="list || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.mailer_account === null">
                        <label class="col-form-label col-lg-3">Choose sub/domain</label>
                        <div class="col-lg-6">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.domain" tag-placeholder=""
                                @search-change="domainFind"
                                :searchable="true" :loading="loadingTypeahead"
                                 placeholder="Search for a sub/domain" label="domain" track-by="domain" :options="domain || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-3">Choose mailer account</label>
                        <div class="col-lg-6">
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.mailer_account" tag-placeholder="" 
                                placeholder="Search for a mailer account" label="name" track-by="_id" 
                                :options="mailer_account || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.mailer_account !== null">
                        <label class="col-form-label col-lg-3">Set limit for sending per domain</label>
                        <div class="col-lg-6">
                            <input type="number" class="form-control" v-model="form.messages_per_domain">
                            <small>If you fill this value, the mailer will pick a domain with currently lowest number of messages sent from this mailer account to send messages, after reaching this above limit it will pick a domain again with the same criteria.</small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="picker1" class="col-sm-3 control-label">
                            Schedule campaign (EST):
                        </label>
                        <div class="col-lg-3" v-if="form.scheduled_at !== null">
                            <!-- <datetime class="form-control" v-model="form.scheduled_at">
                            </datetime> -->
                            <input type="text" class="form-control" v-model="form.scheduled_at" :placeholder="schedulePlaceholder|estTime" />
                            <small>Use <strong>EST time</strong> (UTC-5)</small>
                        </div>
                        <div style="margin-left:20px" class="col-lg-3">
                            <button v-if="form.scheduled_at == null " @click="fillScheduledAt" class="btn btn-sm btn-primary">Enable scheduling</button>
                            <button v-else @click="form.scheduled_at = null" class="btn btn-sm btn-danger">Disable scheduling</button>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="picker1" class="col-sm-3 control-label">
                            Automation:
                        </label>
                        <div class="col-lg-8" v-if="form.automation !== null">
                            <input type="number" class="form-control" v-model="form.automation.wait_seconds" />
                            <small>Number of seconds to wait before sending email (greater than 0)</small><br/>

                            <input type="checkbox" name="sendon" value="true" id="send_on_click" v-model="form.automation.send_on_click"> <label for="send_on_click">Send on click</label><br/>
                            <input type="checkbox" name="sendon" value="true" id="send_on_open" v-model="form.automation.send_on_open"> <label for="send_on_open">Send on open</label><br/>
                            
                            Template: 
                            <div class="form-check form-check-inline">
                                <multiselect v-model="form.automation.template" tag-placeholder="" 
                                @search-change="templateFindByName"
                                :searchable="true" :loading="loadingTypeahead"
                                placeholder="Search for a template name" label="name" track-by="_id" :options="templateList || []" :multiple="false"></multiselect>
                            </div>
                        </div>
                        <div style="margin-left:20px" class="col-lg-3">
                            <button v-if="form.automation == null " @click="fillAutomation" class="btn btn-sm btn-primary">Enable automation</button>
                            <button v-else @click="form.automation = null" class="btn btn-sm btn-danger">Disable automation</button>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-12">
                <fieldset class="mb-3" :class="{'loading-mask': loading}">
                    <div class="form-group row" v-if="form.message_templates.length === 0">
                        <div class="col-lg-6">
                            <ace-editor :editor-id="'query_editor'" @change-content="contentChanged" :content="form.content || ''" lang="html" theme="monokai" v-bind:style="{'width':'100%', height: '800px'}"></ace-editor>
                        </div>
                        <div class="col-lg-6 msg-container" style="padding: 0; height: 800px">
                            <div :class="{'ifrfull': fullscreen}" style="height: 98%; background: white">
                                <p class="alert alert-primary">Use existing email address from particular contact list to use its data when sending test message</p>
                                <button class="btn btn-primary" @click="fullscreen = !fullscreen">Toggle fullscreen</button>
                                <br/>
                                <br/>
                                <!-- <div class="form-control">
                                <multiselect v-model="testSendWorker" tag-placeholder="" 
                                placeholder="Search for an IP address (worker)" label="name" track-by="_id" 
                                :options="workers || []" :multiple="false"></multiselect>
                                </div> -->
                                <input class="form-control" style="margin: 15px" type="text" v-model="testEmail" placeholder="target email" />
                                <br/>
                                <button class="btn btn-primary" @click="sendTest" :disabled="!canTestEmail">Send test message</button><small>Campaign must be saved to send test messages</small>
                                <iframe id="asd" frameBorder="0" style="border: 1px solid grey; width:99%; height: 95%; margin: 5px;"></iframe>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <fieldset class="mb-3" :class="{'loading-mask': loading}">
                            <div class="form-group row">
                                <div class="col-lg-6">
                                    <!-- <div class="form-check form-check-inline">
                                <multiselect v-model="testSendWorker" tag-placeholder="" 
                                placeholder="Search for an IP address (worker)" label="name" track-by="_id" 
                                :options="workers || []" :multiple="false"></multiselect>
                            </div> -->
                                <input class="form-control col-2 form-check-inline" style="margin-left: 25px" type="text" v-model="testEmail" placeholder="target email" />
                                <button class="btn btn-primary" @click="sendTest" :disabled="!canTestEmail">Send test message</button><small>Campaign must be saved to send test messages</small>
                            </div></div></fieldset>
                    </div>

                    <div class="alert alert-danger" v-if="err">{{err}}</div>
                    <div class="alert alert-success" v-if="success">{{success}}</div>
                    <div class="form-group row">
                        <label class="col-form-label col-lg-12">
                            <button type="button" class="btn btn-primary" @click="save()">Save</button>
                            <button type="button" class="btn btn-primary" @click="saveAndClose()">Save & close</button>
                            <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                        </label>
                    </div>
                </fieldset>
            </div>
        </div>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import aceEditor from '../common/Ace.js'
import datetime from 'vuejs-datetimepicker';
import moment from 'moment'

let dbtm

export default {
    components: { modal, aceEditor, datetime },
    props: {
        id: null,
    },
    data() {
        return {
            testEmail: '',
            testSendWorker: '',
            workers: [],
            show_help: false,
            fullscreen: false,
            form: {
                _id: null,
                mailer_account: null,
                domain: null,
                subdomain: null,

                list: null,

                name: null,
                sender_address: null,
                sender_name: null,
                subject: null,
                content: "",
                message_templates: [],
                message_template_id: null,
                automation: null,

                send_limit: 0,
                random_sentences: "",
                random_subjects: "",

                messages_per_domain: 0,

                scheduled_at: null
            },
            err: null,
            success: null,
            loading: false,

            scheduled_at_date: null,
            scheduled_at_time: null,

            mailer_account: [],
            list: [],
            templateList: [],
            domain: [],
            domains: [],

            loadingTypeahead: false
        }
    },
    computed: {
        schedulePlaceholder() {
            return moment()
        },
        canTestEmail() {

            if (this.id === null) {
                return false
            }

            if (this.testEmail.indexOf('@') <= 0) {
                return false
            }

            if (!this.form.mailer_account || !this.form.domain) {
                return false
            }

            return true
        }
    },
    methods: {
        domainFind(query){
            if(query === ''){
                return
            }
            this.domain = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(()=>{
                this.$api.getReq('typeahead/domain?query='+query).then(res => {
                    this.loadingTypeahead = false
                    res.body.data.domain.map(d => {
                        d.subdomains.map(sd => {
                            if (!d.all_subdomains_validated) {
                                return
                            }
                            this.domain.push({
                                _id: d._id,
                                subdomain: sd.subdomain,
                                name: (sd.subdomain && sd.subdomain + "." || '') + d.domain,
                                domain: (sd.subdomain && sd.subdomain + "." || '') + d.domain,
                                mailer_account: d.mailer_account
                            })
                        })
                    })
                })   
            }, 500)
        },
        templateFind(query){
            if(query === ''){
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(()=>{
                this.$api.getReq('template_tags?query='+query).then(res => {
                    this.loadingTypeahead = false   
                    this.templateList = res.body.data
                })   
            }, 500)
        },
        templateFindByName(query){
            if(query === ''){
                return
            }
            this.templateList = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(()=>{
                this.$api.getReq('template?query='+query).then(res => {
                    this.loadingTypeahead = false   
                    this.templateList = res.body.data
                })   
            }, 500)
        },
        templateFindById(id){
            return new Promise(resolve => {
                this.$api.getReq('template/'+id).then(res => {
                    resolve(res.body.data)
                })  
            })
        },
        contactListFind(query){
            if(query === ''){
                return
            }
            this.list = []

            this.loadingTypeahead = true
            clearTimeout(dbtm)
            dbtm = setTimeout(()=>{
                this.$api.getReq('typeahead/contact_list?query='+query).then(res => {
                    this.loadingTypeahead = false   
                    this.list = res.body.data.list
                })   
            }, 500)
        },
        fillScheduledAt: function() {
            this.form.scheduled_at = moment().utcOffset(-5 * 60).add(15, 'minutes').format('DD-MM-YYYY HH:mm:00')
        },
        fillAutomation: function(){
            this.form.automation = {
                wait_seconds: 0,
                send_on_click: false,
                send_on_open: false,
                template: null
            }
        },
        formatDatetime: function(datetime) {
            if (datetime === null) {
                return "[null]";
            } else {
                return datetime.format("YYYY-MM-DD HH:mm:ss");
            }
        },
        contentChanged2(c) {
            this.form.random_sentences = c
        },
        contentChanged3(c) {
            this.form.random_subjects = c
        },
        contentChanged(c) {
            this.form.content = c
            let iframe = document.getElementById('asd')
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(c);
            iframe.contentWindow.document.close();
        },
        sendTest() {
            this.loading = true

            this.$api.postReq(`campaign/${this.id}/test`, {
                email: this.testEmail,
                content: this.form.content,
                worker_id: this.testSendWorker
            }).then(res => {
                this.loading = false
                this.$notify.addSuccess('Mail sent.')
            }).catch(res => {
                this.loading = false
                this.$notify.addError(res.body.error)
            })
        },
        saveAndClose() {
            let that = this
            this.save(null, () => {
                that.$emit('close')
                that.$emit('reload')
            })
        },
        save(_, cb) {
            this.loading = true
            this.err = null

            let automation = undefined
            if(this.form.automation){
                automation = JSON.parse(JSON.stringify(this.form.automation))
                if(this.form.automation.template){
                    automation.template = this.form.automation.template._id
                }
            }

            let f = {
                name: this.form.name,
                scheduled_at: moment(this.form.scheduled_at + ' -05:00', 'DD-MM-YYYY HH:mm:ss ZZ').toDate(),
                list: this.form.list && this.form.list._id,
                domain: this.form.domain && this.form.domain._id,
                subdomain: this.form.domain && this.form.domain.subdomain,
                mailer_account: (this.form.domain && this.form.domain.mailer_account),
                sender_address: this.form.sender_address,
                message_templates: this.form.message_templates.map(t => t._id),
                message_template_id: this.form.message_template_id && this.form.message_template_id._id,
                sender_name: this.form.sender_name,
                automation: automation,
                content: this.form.content,
                subject: this.form.subject,
                messages_per_domain: this.form.messages_per_domain,

                send_limit: this.form.send_limit,
                random_sentences: this.form.random_sentences,
                random_subjects: this.form.random_subjects
            }

            if(this.form.mailer_account){
                f.mailer_account = this.form.mailer_account._id
                delete f.domain
            }

            if (typeof this.id === 'string') {
                f._id = this.id
            }

            if(typeof this.id === 'string' && this.id.indexOf('clone_') === 0){
                delete f._id
            }

            this.$api.postReq('campaign', f).then(res => {
                cb && cb()
                this.loading = false
                this.success = 'Campaign saved'
                this.id = res.body.data._id
                setTimeout(()=>{
                    this.success = null
                }, 1000)
            }).catch(res => {
                this.loading = false
                this.err = res.body.error
            })
        },
    },
    mounted() {
        this.loading = 1

        this.$api.getReq('campaign_create').then(res => {
            this.mailer_account = res.body.data.mailer_account
            this.domains = res.body.domain
            this.workers = res.body.data.workers.map(w => {
                return {
                    _id: w._id,
                    name: w.name + " ips: "+w.ips.join(", ")
                }
            })
            this.form.send_limit = res.body.data.default_throttle || 0
            this.loading--

            // cut here --------

            if (typeof this.id === 'string') {
                this.loading++

                let clone = false
                let id = this.id
                if(id.indexOf("clone_") === 0){
                    id = id.substr(6)
                    clone = true
                }

                this.$api.getReq('campaign/' + id).then(async res => {
                    this.form.name = res.body.campaign.name

                    if(clone){
                        this.form.name = 'Copy of '+this.form.name
                    }

                    this.form.domain = res.body.campaign.domain

                    if(res.body.campaign.subdomain){
                        this.form.domain.domain = res.body.campaign.subdomain + '.' + this.form.domain.domain
                    }

                    this.form.list = res.body.campaign.list

                    this.form.subject = res.body.campaign.subject
                    this.form.sender_address = res.body.campaign.sender_address
                    this.form.sender_name = res.body.campaign.sender_name
                    this.form.content = res.body.campaign.content
                    this.form.random_sentences = res.body.campaign.random_sentences
                    this.form.random_subjects = res.body.campaign.random_subjects
                    this.form.message_templates = res.body.campaign.message_templates
                    this.form.messages_per_domain = res.body.campaign.messages_per_domain
                    this.form.automation = res.body.campaign.automation || null
                    this.form.message_template_id = res.body.campaign.message_template_id

                    if(this.form.automation){
                        let template = await this.templateFindById(this.form.automation.template)
                        this.form.automation.template = {
                            _id: this.form.automation.template,
                            name: template.name
                        }
                    }
                    if(this.form.message_template_id){
                        let template = await this.templateFindById(this.form.message_template_id)
                        this.form.message_template_id = {
                            _id: this.form.message_template_id,
                            name: template.name
                        }
                    }

                    if(res.body.campaign.send_limit > 0){
                        this.form.send_limit = res.body.campaign.send_limit
                    }

                    this.loading--

                    this.form.mailer_account = this.mailer_account.filter(r => r._id === res.body.campaign.mailer_account).pop()
                })
            }
        })


    }
}
</script>
<style>
.modal-full {
    height: 95% !important;
    top: 0;
    width: 99% !important;
}

.ifrfull {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 1000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modal/Campaign.vue